module.exports = __webpack_public_path__ + "static/media/icon-delivery.95d3139d.svg";